class moreResultat extends ListeResultat {
	initialize() {
		this.handlerPagination(settingsListeResultats.resultats.showPagination);
	}

	_GetResultats() {
		var url = settingsListeResultats.lr.ListeVoyages;
		var indexNumeroPageVoyage = document.getElementById('numeroPageVoyage').value;

		if (isNaN(parseInt(indexNumeroPageVoyage))) {
			indexNumeroPageVoyage = 0;
		} else {
			indexNumeroPageVoyage = parseInt(indexNumeroPageVoyage);
		}

		$.ajax({
			url: url,
			type: "POST",
			data: {
				index: indexNumeroPageVoyage
			},
			beforeSend: function () {
				document.body.classList.add('loading');
			},
			success: function (data) {
				indexNumeroPageVoyage++;
				$('#blockresults').append(data);
				document.getElementById('numeroPageVoyage').value = indexNumeroPageVoyage;
				window.sessionStorage.setItem('numeroPageVoyage', indexNumeroPageVoyage);
			},
			error: function (err) {
				document.location.reload(true);
			},
			complete: function () {
				// On met à jour les différents champs
				let nbreVoyagesTotal = settingsListeResultats.resultats.nbreVoyages;
				let nbreVoyagesAffiches = $('#blockresults .circuit').length;
				document.getElementById('nbreCircuitsAffiches').value = nbreVoyagesAffiches;
				settingsListeResultats.resultats.nbreVoyagesAffiches = nbreVoyagesAffiches;
				if (nbreVoyagesAffiches === nbreVoyagesTotal) {
					$('[data-js="getMoreResultat"]').hide();
					settingsListeResultats.resultats.showPagination = false;
				}

				$('.jAddToSelection').off('click')
				selection.init(settingsApp.favoris);
				JSON.parse(document.querySelector('[data-js="toggleMap"]').dataset.map) && lr.toggleMap(document.querySelector('[data-js="toggleMap"]'))

				document.body.classList.remove('loading');
				/// Uniquement pour terdav.be
				settingsApp.app === 'TDV' && settingsApp.belge && commons.convertButtonToLink('data-voyage');
			}
		});
	}

	handlerPagination(a) {

		let self = this;
		let btnMoreResultats = document.querySelector('[data-js="getMoreResultat"]');
		if (btnMoreResultats != null && a) {
			btnMoreResultats.addEventListener('click', function () {
				self._GetResultats();
			});
		}

	}
}